export const formatToRub = (cost: string): string =>
  cost
    .split('')
    .reverse()
    .reduceRight((price, char, index) => (index % 3 ? price + char : price + char + ' '), '') + '₽';
